module.exports = __webpack_public_path__ + "img/burger.78e52d34.png";